// Copyright (c) 2017 Comsearch, Inc., All rights reserved

import React from 'react'
import { func, object, string } from 'prop-types'

const Checkbox = props => {
  const {
    id,
    input,
    label,
    onChangeCustom,
    value,
  } = props

  // Redux Form, as of v6 does not handle grouped checkboxes properly.
  // It treats every checkbox's value as a boolean and associates it by
  // its name attribute. Because of this, grouped checkbox values are
  // manually controlled by this custom change handler.
  // onBlur is added to circumvent the default redux-form blur handler
  // which would assign a true/false value again.
  const handleChange = e => {
    // value may be a string from redux-form
    // when initialized value was an empty array
    const newValue = input.value.length ? [...input.value] : []
    if (e.target.checked) {
      newValue.push(value)
    } else {
      newValue.splice(newValue.indexOf(value), 1)
    }
    return input.onChange(newValue)
  }

  const onChangeC = e => onChangeCustom(e, handleChange)

  return (
    <label
      className={'checkbox-option'}
      title={label}>
      <input
        {...input}
        id={id}
        type={'checkbox'}
        checked={input.value.indexOf(value) !== -1}
        value={value}
        onChange={onChangeCustom ? onChangeC : handleChange}
        onBlur={(e) => e}/>
      <span>{label}</span>
    </label>
  )
}

Checkbox.propTypes = {
  id: string.isRequired,
  input: object.isRequired,
  label: string.isRequired,
  onChangeCustom: func,
  value: string.isRequired,
}

export default Checkbox
